import React from 'react';
import { GraphQlRequestErrorCode } from '../../../../api/types';
import { GraphQLError } from '../../../errors';
import { ChartDataFetchError } from '../../charts/ChartDataFetchError';
import InsufficientPermissions from './InsufficientPermissions';

export interface ErrorDisplayProps {
  error: Error;
  className?: string;
  variant?: 'inline' | 'tooltip';
  fallback?: React.ReactNode;
  whiteIcon?: boolean;
}

export const ErrorDisplay = (props: ErrorDisplayProps) => {
  const {
    error,
    className,
    variant = 'inline',
    whiteIcon = false,
    fallback = <ChartDataFetchError errorData={{ error }} />,
  } = props;

  // Check if it's a GraphQLError
  if (error instanceof GraphQLError) {
    // Check the error code to determine which component to show
    switch (error.errorCode) {
      case GraphQlRequestErrorCode.Err_AuthorizationDenied:
        return (
          <InsufficientPermissions
            className={className}
            variant={variant}
            whiteIcon={whiteIcon}
          />
        );

      // Add more error cases here as needed
      default:
        // For unhandled GraphQL errors, return null
        return <>{fallback}</>;
    }
  }

  // For non-GraphQL errors, return null
  return <>{fallback}</>;
};

export default ErrorDisplay;
